$j = jQuery.noConflict();
$j.ui.dialog.prototype._focusTabbable = $j.noop;